module.exports = __webpack_public_path__ + "img/6tirDir.7217946f.png";